module.exports = __webpack_public_path__ + "static/tooltip-forms-do-5f1463f44c98ee2f95325c74ded642a2.png";